import * as React from 'react';

type Props = {
    width?: number;
};

export function TrialOnboardingScenery(props: Props) {
    return (
        <svg
            width={props.width}
            viewBox='0 0 1220 424'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M-26.75 0c47.316 0 86.7 33.966 95.097 78.846C70.175 88.617 78.059 96.75 88 96.75h42.75c35.466 0 65.603 22.794 76.57 54.531 2.934 8.491 10.336 15.219 19.319 15.219h19.986c25.474 0 46.125 20.651 46.125 46.125s-20.651 46.125-46.125 46.125H-132.5c-1.636 0-3.26-.056-4.871-.152a94 94 0 0 1-5.254.152c-51.57 0-93.375-41.805-93.375-93.375S-194.195 72-142.625 72q1.928 0 3.837.078c9.953.404 19.556-5.525 23.606-14.625C-100.118 23.603-66.192 0-26.75 0M1223.7 91.688c-52.53 0-96.25 33.998-105.58 78.921-2.02 9.781-10.78 17.922-21.81 17.922h-47.46c-39.38 0-72.833 22.816-85.008 54.584-3.257 8.499-11.475 15.233-21.448 15.233h-22.188c-28.28 0-51.206 20.671-51.206 46.17s22.926 46.17 51.206 46.17H1341.1c1.81 0 3.62-.057 5.41-.152 1.93.096 3.87.152 5.83.152 57.25 0 103.66-41.846 103.66-93.466s-46.41-93.465-103.66-93.465q-2.145 0-4.26.078c-11.05.405-21.71-5.53-26.21-14.639-16.72-33.884-54.39-57.508-98.17-57.508'
                fill='#fff'
            />
            <path
                d='m267.541 149.468 459.628 185.186A31.66 31.66 0 0 1 747 364.023c0 17.488-14.176 31.665-31.664 31.665H-72.587c-41.097 0-74.413-33.316-74.413-74.414 0-28.52 16.301-54.531 41.967-66.966l101.738-49.294c20.315-9.842 43.973-10.591 64.91-2.156 24.51 9.875 52.469 7.074 74.45-7.59l57.183-38.147a80 80 0 0 1 74.293-7.653'
                fill='#c4eecc'
            />
            <path d='M249 328.688h436.5l-201 70z' fill='#3b9ed7' />
            <path
                d='M969.742 239.473 226.021 432.605A10.71 10.71 0 0 0 218 442.974c0 5.917 4.797 10.714 10.713 10.714H1368.03v-183l-325.81-36.399a200 200 0 0 0-72.478 5.184'
                fill='#91c73e'
            />
            <path
                d='M288.493 293.412h-37.986c-5.36 0-9.204-5.169-7.661-10.302l24.739-82.324c.57-1.899 3.26-1.899 3.83 0l24.739 82.324c1.543 5.133-2.301 10.302-7.661 10.302'
                fill='#2e9942'
            />
            <path
                d='M270.082 241.203v77.659m.603-45.36-10.935-10.94m10.636 23.039 10.178-10.179'
                stroke='#6a4b1c'
                strokeWidth='4'
            />
            <g opacity='.8'>
                <path
                    d='M199.216 248.565v62.127m.482-36.288-8.748-8.752m8.509 18.431 8.143-8.143'
                    stroke='#e7c580'
                    strokeWidth='2.592'
                />
                <path
                    d='M213.944 290.332h-30.388c-4.288 0-7.363-4.135-6.129-8.242l19.791-65.859c.456-1.519 2.608-1.519 3.065 0l19.79 65.859c1.235 4.107-1.84 8.242-6.129 8.242'
                    fill='#2e9942'
                />
            </g>
            <g opacity='.6'>
                <path
                    d='M147.033 254.739v31.063m.241-18.144-4.374-4.376m4.254 9.216 4.072-4.071'
                    stroke='#e7c580'
                    strokeWidth='1.296'
                />
                <path
                    d='M154.397 275.622h-15.194a3.2 3.2 0 0 1-3.064-4.12l9.895-32.93c.229-.76 1.304-.76 1.533 0l9.895 32.93a3.2 3.2 0 0 1-3.065 4.12'
                    fill='#2e9942'
                />
            </g>
            <ellipse cx='1176.68' cy='303.977' rx='40.05' ry='4.95' fill='#72a91e' />
            <path
                d='M1140.06 266.22c-33.44 0-60.55-26.498-60.55-59.184 0-18.508 8.69-35.03 22.3-45.883a38.5 38.5 0 0 1-1.65-11.168c0-21.696 18.04-39.284 40.3-39.284 22.25 0 40.29 17.588 40.29 39.284 0 4.069-.63 7.994-1.81 11.684 13.24 10.857 21.66 27.151 21.66 45.367 0 32.686-27.11 59.184-60.54 59.184'
                fill='#2e9942'
            />
            <path
                d='M1139.85 149.783V305.1m1.21-112.185 22.28-22.275m-22.28 43.74-37.88-21.87m20.26 12.15-12.15 12.15m29.17 29.768 36.35-36.357'
                stroke='#e7c580'
                strokeWidth='6.48'
            />
            <ellipse
                cx='21.192'
                cy='2.619'
                rx='21.192'
                ry='2.619'
                transform='matrix(-1 0 0 1 899.385 287.451)'
                fill='#72a91e'
            />
            <path
                d='M858.572 269.092c17.151-.001 31.153-13.175 31.996-29.736 8.73-2.603 15.078-10.518 15.078-19.881 0-11.48-9.546-20.788-21.323-20.788q-.384.001-.765.016c-1.299-12.917-12.61-23.016-26.374-23.016-14.636 0-26.5 11.417-26.5 25.5q0 1.409.156 2.779c-10.12 1.621-17.84 10.185-17.84 20.509 0 9.039 5.918 16.729 14.182 19.592 2.98 14.28 15.901 25.025 31.39 25.025'
                fill='#2e9942'
            />
            <path
                d='M858.683 207.479v82.186m-.644-56.005 16.407-9.472m-16.086 26.51-19.238-19.239M867 229.688l9.5 5.484M858 250.188h-15'
                stroke='#e7c580'
                strokeWidth='5'
            />
            <path
                d='m178.823 279.493 585.531 184.823A10.94 10.94 0 0 1 772 474.748c0 6.042-4.898 10.94-10.939 10.94H-172V335.097l243.336-59.21a200 200 0 0 1 107.487 3.606'
                fill='#2e9942'
            />
            <path
                opacity='.4'
                d='M496.355 277.575c-2.119 7.135 1.176 11.695 3.985 13.713.69.496 1.636.346 2.172-.313 4.436-5.457.385-11.075-3.446-14.232a1.687 1.687 0 0 0-2.711.832M980.99 154.716c-6.499 3.629-7.324 9.194-6.722 12.6.147.837.929 1.39 1.773 1.292 6.986-.809 8.009-7.659 7.47-12.595a1.687 1.687 0 0 0-2.521-1.297'
                fill='#91c73e'
            />
            <path
                d='M1191.67 342.37c2.89 6.858 8.34 8.288 11.79 8.064.84-.055 1.48-.771 1.48-1.621-.04-7.033-6.74-8.801-11.7-8.807a1.688 1.688 0 0 0-1.57 2.364'
                fill='#2e9942'
            />
            <path
                d='M103.96 353.326c-4.676 3.049-5.006 7.256-4.381 9.773.154.618.767.992 1.394.876 5.185-.965 5.598-6.144 4.94-9.809a1.264 1.264 0 0 0-1.953-.84'
                fill='#91c73e'
            />
        </svg>
    );
}
